export const reduxKey = '@@Mention';

//# sourceMappingURL=constants.js.map